import { useState } from 'react';
import { parse } from 'date-fns';
export default function useDatepickerConfig(props) {
    const { formattedAvailableDates, toDate, fromDate, } = props;
    const [minDate, useMinDate] = useState(parse(fromDate, 'dd/MM/yyyy', new Date()));
    const [maxDate] = useState(parse(toDate, 'dd/MM/yyyy', new Date()));
    return {
        minDate,
        maxDate,
    };
}
